import { StepState } from '@/features/actsAndDocuments/actsAndDocumentsSlice';
import { ViolationActRequestBody } from '@/features/violationActs/types';
import { ViolationActInfoFormDefaultValues } from '@/forms/ViolationActInfoForm';
import { extractDataByPath } from '@/pages/ViolationActForm/hooks';
import {
  getActFormDate,
  getDevices,
  getModems,
} from '@/pages/ViolationActForm/hooks/submitFormUtils';

import {
  ActsAndDocumentsFormSteps,
  FileLikeObject,
} from '@components/ActsAndDocumentsForm';

type PrepareRequestBodyArgs = {
  stepsState: StepState<string>;
  commercialMeteringPointId?: string;
  meteringPointId?: string;
  steps: ActsAndDocumentsFormSteps;
  isEditMode?: boolean;
  documentsToDelete?: FileLikeObject[];
};

export const prepareRequestBody = ({
  stepsState,
  commercialMeteringPointId,
  steps,
  isEditMode,
  documentsToDelete,
}: PrepareRequestBodyArgs): ViolationActRequestBody => {
  const getByPath = extractDataByPath<ViolationActInfoFormDefaultValues>(
    stepsState[steps.Information]?.data,
  );

  const date = getActFormDate({
    date: getByPath('date', ''),
    startTime: getByPath('startTime', ''),
  });

  const devicesStepData = stepsState[steps.Devices]?.data ?? [];
  const unpreparedDevices = devicesStepData.filter(
    device => device.isModem === undefined,
  );
  const unpreparedModems = devicesStepData.filter(
    device => device.isModem === true,
  );

  return {
    commercialMeteringPointId,
    id: getByPath('id'),
    violationTypeId: getByPath('violationTypeId'),
    violationMeasureId: getByPath('violationMeasureId'),
    resultId: getByPath('resultId'),
    violationDecisionId: getByPath('violationDecisionId'),
    comment: getByPath('comment'),
    deadline: getByPath('deadline'),
    executionDate: getByPath('executionDate'),
    date,
    number: getByPath('number', ''),
    performerId: getByPath('performerId'),
    devices: getDevices(unpreparedDevices, date, isEditMode),
    modems: getModems(unpreparedModems, date, isEditMode),
    documentsToDelete: (documentsToDelete ?? []).map(d => d.name),
  };
};
